import { GridItem } from '@bnnvara/grids';
import { propTypes } from '@bnnvara/icons/src/components/props';
import PropTypes from 'prop-types';
import React from 'react';

import PersonSummary from '../components/PersonSummary';

const ComposablePersonSummary = ({ persons }) => {
  // Because persons can have more than 1 person. We decided to always take the 1st in the array to display.
  if (!persons.length && !persons[0]) {
    return null;
  }
  return (
    <GridItem
      columnStartSm="1"
      columnEndSm="span 12"
      columnStartMd="2"
      columnEndMd="span 10"
      columnStartLg="3"
      columnEndLg="11"
    >
      <PersonSummary
        name={persons[0].name}
        subtitle={persons[0].subtitle}
        url={persons[0].url}
        photo={persons[0].photo}
      />
    </GridItem>
  );
};

ComposablePersonSummary.defaultProps = {
  persons: [],
};

ComposablePersonSummary.propTypes = {
  persons: PropTypes.arrayOf(
    PropTypes.shape({
      id: propTypes.string,
      name: PropTypes.string,
      subtitle: PropTypes.string,
      description: PropTypes.string,
      url: PropTypes.string,
      slug: PropTypes.string,
      photo: PropTypes.shape({
        id: propTypes.string,
        altText: PropTypes.string,
        url: PropTypes.string,
      }),
      firstCharacter: PropTypes.string,
    })
  ),
};

export default ComposablePersonSummary;
